import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {isPristine, isSubmitting, reset, submit} from "redux-form";
import {substanceTRFormActions, substanceTRFormSelectors} from "../../../../redux/form/substanceTRForm";
import {referentialSelectors} from "../../../../redux/referentials";
import SubstanceTRModal from "./SubstanceTRModal";
import formNames from "../../../../constants/formNames";
import {applicationSelectors} from "../../../../redux/application";
import {substanceTRActions, substanceTRTypes} from "../../../../redux/substanceTR";

const formName = formNames.substanceTR;

const SubstanceTRModalContainer = props => (
  <SubstanceTRModal {...props}/>
);

const mapStateToProps = (state, {substanceId}) => {
  const isFormSubmitting = isSubmitting(formName)(state);
  const initialFormValues = substanceTRFormSelectors.getInitialValues(state, substanceId);
  const isFormPristine = isPristine(formName)(state);
  return {
    title: `${I18n.t('substanceTRFormModal.title')}`,
    initialValues: initialFormValues,
    languages: referentialSelectors.getLanguageList(state).filter(elem => elem.Alpha2 !== 'en'),
    isSaveDisabled: isFormSubmitting || isFormPristine,
    isLoading: applicationSelectors.isLoading(state, substanceTRTypes.SUBSTANCE_TR_LIST.REQUEST),
  };
};

const mapDispatchToProps = (dispatch, {substanceId}) => {
  return ({
    onLoad: () => {
      dispatch(substanceTRActions.listSubstanceTR.request({ substanceId }));
    },
    onSaveButtonClick: () => dispatch(submit(formName)),
    onSubmit: data => substanceTRFormActions.submitSubstanceTRForm(data, dispatch),
    onCancelButtonClick: () => {
      dispatch(reset(formName));
    },
  });
};

SubstanceTRModalContainer.defaultProps = {
  categoryId: undefined,
};

SubstanceTRModalContainer.propTypes = {
  title: PropTypes.string.isRequired,
  categoryId: PropTypes.number,
  onSaveButtonClick: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubstanceTRModalContainer);
